import { useFela } from 'react-fela';

import { SecretDetailSections } from '../SecretDetailSections';
import { SecretHeader } from '../SecretHeader';
import { SecretNameWithIcon } from '../SecretNameWithIcon';
import { CreatorTag } from './CreatorTag';
import { DetailButtons } from './DetailButtons';
import * as felaRules from './SecretDetail.rules';
import { SecretDetailAlerts } from './SecretDetailAlerts';
import { useSecretDetailContext } from './SecretDetailProvider';
import { UpdatedAndCreatedDates } from './UpdatedAndCreatedDates';

export const SecretDetail = () => {
    const secret = useSecretDetailContext();

    const { css } = useFela();

    const { createdBy } = secret;

    return (
        <div className={css(felaRules.pageContainer)}>
            <SecretHeader>
                <DetailButtons />
            </SecretHeader>
            <SecretDetailAlerts />
            <main className={css(felaRules.contentContainer)}>
                <SecretNameWithIcon secret={secret} />
                {createdBy ? <CreatorTag creator={createdBy} /> : null}
                <SecretDetailSections />
                <UpdatedAndCreatedDates />
            </main>
        </div>
    );
};
